import { Component, Input } from '@angular/core';

const WORD_ONLINE_URL = 'https://go.microsoft.com/fwlink/?linkid=2261098&templateid=WA200010237&templatetitle=Explain';
const WORD_DESKTOP_URL_TEMPLATE =
  'ms-word:https://api.addins.store.office.com/addinstemplate/fr-FR/{correlationId}/WA200010237/none/Explain.docx?omexsrctype=1&isexternallink=1';

@Component({
  selector: 'app-response-project-wizard-word-card',
  templateUrl: './response-project-wizard-word-card.component.html',
  styleUrls: ['./response-project-wizard-word-card.component.scss'],
})
export class ResponseProjectWizardWordCardComponent {
  @Input() showHeader = true;
  @Input() compact = false;
  showManual = false;

  readonly wordDesktopUrl = WORD_DESKTOP_URL_TEMPLATE.replace('{correlationId}', crypto.randomUUID());
  readonly wordOnlineUrl = WORD_ONLINE_URL;

  readonly manualSteps = [
    'tenders.responses.wizard.word-card-manual-step-1',
    'tenders.responses.wizard.word-card-manual-step-2',
    'tenders.responses.wizard.word-card-manual-step-3',
  ];

  readonly manualStepsCompact = [
    'tenders.responses.wizard.word-card-manual-step-compact-1',
    'tenders.responses.wizard.word-card-manual-step-compact-2',
    'tenders.responses.wizard.word-card-manual-step-compact-3',
  ];
}
